import { render, staticRenderFns } from "./StudyComments.vue?vue&type=template&id=1a367d56"
import script from "./StudyComments.vue?vue&type=script&lang=js"
export * from "./StudyComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports